const keyFor = (requestId) => `healbid:requestFlowDraft:${String(requestId || "").trim()}`;

export function readRequestDraft(requestId) {
  if (!requestId) return {};
  try {
    const raw = sessionStorage.getItem(keyFor(requestId));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function saveRequestDraft(requestId, partial) {
  if (!requestId || !partial || typeof partial !== "object") return;
  try {
    const next = { ...readRequestDraft(requestId), ...partial };
    sessionStorage.setItem(keyFor(requestId), JSON.stringify(next));
  } catch {
    // ignore
  }
}

export function clearRequestDraft(requestId) {
  if (!requestId) return;
  try {
    sessionStorage.removeItem(keyFor(requestId));
  } catch {
    // ignore
  }
}
